import { Expose, Type } from 'class-transformer'
import { CampaignTypeEnum } from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { CampaignStatusEnum } from '@interfaces/promotionCampaign/CampaignStatusEnum'
import { WholeStoryDiscountTypeEnum } from '@interfaces/promotionCampaign/WholeStoryDiscountTypeEnum'
import { FreeReadingTypeEnum } from '@interfaces/promotionCampaign/FreeReadingTypeEnum'
import { CampaignBookItemType } from './CampaignBookItemType'

export class CampaignType {
  @Expose() id: number

  @Expose() name: string

  @Expose() type: CampaignTypeEnum

  @Expose() status: CampaignStatusEnum

  @Expose() wholeStoryDiscountType?: WholeStoryDiscountTypeEnum

  @Expose() freeReadingType?: FreeReadingTypeEnum

  @Expose() bookCount: number

  @Expose() startDate: string

  @Expose() endDate: string

  @Expose() createdAt: string

  @Expose() updatedAt: string

  @Expose()
  @Type(() => CampaignBookItemType)
  items?: CampaignBookItemType[]
}
